export default function MetaCampaignModel(dict) {
    if (!dict) {
        this.group = null;
        this.pointServices = false;
        this.minPrivilege = [];
        this.matchPrivilege = [];
        this.disabled = false;
        return;
    }

    this.group = dict.Group || null;
    this.pointServices = dict.PointServices || false;
    this.disabled = dict.Disabled || false;
    
    this.minPrivilege = [];
    if (dict.MinPrivilege && dict.MinPrivilege instanceof Array) {
        for (var i = 0; i < dict.MinPrivilege.length; i++) {
            this.minPrivilege.push({
                privilegeId: dict.MinPrivilege[i].PrivilegeId || null,
                level: dict.MinPrivilege[i].Level || null
            });
        }
    }
    
    this.matchPrivilege = [];
    if (dict.MatchPrivilege && dict.MatchPrivilege instanceof Array) {
        for (var j = 0; j < dict.MatchPrivilege.length; j++) {
            this.matchPrivilege.push({
                privilegeId: dict.MatchPrivilege[j].PrivilegeId || null,
                level: dict.MatchPrivilege[j].Level || null
            });
        }
    }
}